
import React from 'react'

import Logo from '@assets/images/notifications/logo.svg'
import SentIcon from '@assets/images/notifications/sent.svg'
import PaidIcon from '@assets/images/notifications/paid.svg'
import HandshakeIcon from '@assets/images/notifications/handshake.svg'
import BankingIcon from '@assets/images/notifications/banking.svg'
import AlertIcon from '@assets/images/notifications/alert.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import OfficeIcon from '@assets/images/icons/menu/menu-office.svg'
import SignaturePenIcon from '@assets/images/icons/signature_pen.svg'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  wrapper: ({ small }: { small: boolean }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: `0 0 ${small ? 30 : 50}px`,
    height: small ? 30 : 50,
    borderRadius: '50%',
    background: '#fff',
    '& path:not([fill])': {
      fill: theme.primary, // ee751c
      '&.superlight': {
        fill: theme.primarySuperLight, // faac71
      },
    },
  }),
}))

const NotificationIcon = ({ icon, height, width, small = false }) => {
  const classes = useStyles({ small })

  const props = {
    svg: Logo,
    width,
    height,
  }
  switch (icon) {
    case 'handshake':
      props.svg = HandshakeIcon
      break
    case 'at':
      props.svg = SentIcon
      break
    case 'alert':
      props.svg = AlertIcon
      break
    case 'banking':
      props.svg = BankingIcon
      break
    case 'euro':
      props.svg = PaidIcon
      break
    case 'office':
      props.svg = OfficeIcon
      break
    case 'signature':
      props.svg = SignaturePenIcon
      break
  }

  return (
    <div className={classes.wrapper}>
      <SVGIcon {...props} />
    </div>
  )
}

export default NotificationIcon
